import { render, staticRenderFns } from "./Subscribe.vue?vue&type=template&id=20b6b146&scoped=true&"
import script from "./Subscribe.vue?vue&type=script&lang=js&"
export * from "./Subscribe.vue?vue&type=script&lang=js&"
import style0 from "./Subscribe.vue?vue&type=style&index=0&id=20b6b146&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b6b146",
  null
  
)

export default component.exports